{
  "bookingWidgetTabs": {
    "hotels": {
      "tabTitle": "Hotels",
      "ctaText": "View hotel offers",
      "poweredBy": "Powered by",
      "staticNotification": {
        "content": "Discover our partner's hotel offers around the globe.",
        "redirect": "We will take you to Hotels.com website in English."
      }
    }
  },
  "bookingWidget": {
    "hotels": {
      "aviosNotification": "Finnair Plus members can collect Avios with each hotel booking."
    }
  }
}
